import { FundOutlined } from '@ant-design/icons/lib/icons';
import { Col, Row } from 'antd';
import { MAlert, MTypography } from 'src/lib';
import { OfferOrder } from 'src/models';
import { ColorConstant } from 'src/styles';

import { OfferOrderStatusTag } from '../OfferOrderStatusTag/OfferOrderStatusTag';

import * as Styles from './OfferOrderTypeCol.styles';

interface OfferOrderTypeColProps {
  testId?: string;
  value: OfferOrder;
  onViewMore: () => void;
}

export const OfferOrderTypeCol = ({ value, onViewMore, testId }: OfferOrderTypeColProps) => (
  <Row>
    <Col span={24}>
      <Row gutter={[8, 1]} data-testid={testId}>
        <Col className={Styles.description}>Offer Order(s)</Col>
        <Col>
          <OfferOrderStatusTag value={value.status.label} />
        </Col>
        <Col className={Styles.descriptionSubtitle} span={24}>
          {value.offerName}
        </Col>
      </Row>
      <Row>
        {value.paymentType.isCard ? (
          <MAlert
            condensed
            type='warning'
            icon={<FundOutlined />}
            description={
              <>
                <MTypography variant='body1' inline>
                  Securities purchased by credit card are funded and held outside of your My IPO account.
                </MTypography>
                <MTypography variant='body1' inline color={ColorConstant.ORANGE8}>
                  {' '}
                  [View More]
                </MTypography>
              </>
            }
            onClick={onViewMore}
            testId={'history-order-creditcard-disclaimer'}
          />
        ) : value.isExternal ? (
          <MAlert
            condensed
            type='warning'
            description={
              <>
                <MTypography variant='body1' inline>
                  This type of offering is held & funded outside of My IPO.
                </MTypography>
                <MTypography variant='body1' inline color={ColorConstant.ORANGE8}>
                  {' '}
                  [View More]
                </MTypography>
              </>
            }
            onClick={onViewMore}
            testId={'history-order-external-disclaimer'}
          />
        ) : null}
      </Row>
    </Col>
  </Row>
);
